import React from 'react';
import ReactDOM from 'react-dom';
import createReactClass from 'create-react-class';
import classnames from 'classnames';
import {Form} from 'modules/form';
import {Button, Card} from 'uiKit';
import AlertInfo from 'modules/app/components/alertInfo';
import LP from 'modules/app/helpers/lp';
import LoginOAuth from 'modules/login/components/loginOAuth';
import Columns from 'modules/app/components/columns';
import ReactGA from 'react-ga';

var RegisterNewUser = createReactClass({

    componentDidMount: function() {

        if (window.generalSettings._shouldUseGoogleAnalytics && window.generalSettings._googleAnalyticsTrackingId) {
            ReactGA.initialize(window.generalSettings._googleAnalyticsTrackingId);
            ReactGA.set({page: location.pathname});
            ReactGA.pageview(location.pathname);
        }
    },

    getClassName: function() {
        return classnames('register', {
            'has-sso': (authentication._shouldAllowOpenRegistrations)
        });
    },

    renderBody: function() {

        if (this.props.hasRegistered) {
            return (
                <Card className="register-new-user-card">
                    <p>{LP('users', 'registrationLinkSent', 'sentencecase')} <a aria-label={LP('login', 'returnToSignInAriaLabel')} href="/login">{LP('users', 'registerGoToLink', 'sentencecase')}</a></p>
                    <br />
                    <p>{LP('users', 'registerSafeSenderList')}</p>
                </Card>
            );
        }

        var lpString = LP('users', 'registerBody');

        if (lpString) {
            return (
                <div className="register-body" dangerouslySetInnerHTML={{__html: lpString}} />
            )
        }
    },

    renderForm: function(length) {
        var className = "register-new-user-forms";

        if (length === 0) {
            var className = "register-new-user-forms oauth-is-not-enabled"
        };

        return (
            <div className="register-new-user-forms">
                <Form
                    model={this.props.user}
                    schema={this.props.schema}
                    onUpdate={this.props.onUpdateField}
                    form={{actions: this.props.formActions}}
                    shouldValidateOnMount={false}
                    onLoad={this.props.onFormLoaded}
                />
                {this.renderAlert()}
                <Button disabled={this.props.hasError} className="button primary large full-width" onClick={this.props.onRegisterClicked} text={LP('users', 'register', 'sentencecase')} />
            </div>
        );
    },

    renderAlert: function() {
        if (this.props.hasError && this.props.errorMessage) {
            return (
                <AlertInfo
                    text={this.props.errorMessage}
                    type="warning"
                    icon="alert"
                />
            );
        }
    },

    renderSSO: function() {
        return (
            <LoginOAuth
                onGoogleOAuthClicked={this.props.onGoogleOAuthClicked}
                onLinkedInOAuthClicked={this.props.onLinkedInOAuthClicked}
                onTwitterOAuthClicked={this.props.onTwitterOAuthClicked}
                onFacebookOAuthClicked={this.props.onFacebookOAuthClicked}
            />
        )
    },

    renderColumns: function(length) {

        if (this.props.hasRegistered) {
            return null;
        }

        if (authentication._shouldAllowOpenRegistrations && length > 0) {
            return (
                <Columns columns={[this.renderForm(), this.renderSSO()]} />
            );
        } else {
            return this.renderForm(length);
        }
    },

    renderLogo: function() {
        var logo = window.generalSettings._logo;
        var shouldShowLogoOnLogin = window.generalSettings._shouldShowLogoOnLogin;

        if (logo && shouldShowLogoOnLogin) {
            logo = logo.replace('/images/', '/logo/');

            if (window.location.pathname.split('/')[2]) {
                logo = `../../${logo}`;
            }

            return (
                <div className="register-logo" style={{height: window.generalSettings._navigationHeight + 'px'}}>
                    <div className="register-logo-inner">
                        <a href='/'>
                            <img
                                className="register-logo-graphic"
                                src={logo}
                                style={{height: (window.generalSettings._navigationHeight - 18) + 'px'}}
                            />
                        </a>
                    </div>
                </div>
            );
        }
    },

    render: function() {
        var authArray = [
            {
                type: "GoogleOauth",
                isEnabled: authentication._shouldAllowGoogleOAuth
            },
            {
                type: "LinkedInOauth",
                isEnabled: authentication._shouldAllowLinkedInOAuth,
            },
            {
                type: "TwitterOauth",
                isEnabled: authentication._shouldAllowTwitterOAuth,
            },
            {
                type: "FacebookOauth",
                isEnabled: authentication._shouldAllowFacebookOAuth,
            }
        ];

        var filteredAuthArray = _.filter(authArray, (oauth) => {
            return oauth.isEnabled === true;
        });

        var length = filteredAuthArray.length;

        var className = "register-new-user";

        if (length === 0) {
            var className = "register-new-user oauth-is-not-enabled"
        };

        var logo = window.generalSettings._logo;
        var shouldShowLogoOnLogin = window.generalSettings._shouldShowLogoOnLogin;
        var styles = {};

        if (logo && shouldShowLogoOnLogin) {
            styles = {"paddingTop": window.generalSettings._navigationHeight + 'px'};
        } else {
            styles = null;
        }

        return (
            <div className="register-container">
                <Card className={this.getClassName()}>
                    {this.renderLogo()}
                    <div className={className}>
                        <div role="alert" aria-label={this.props.hasRegistered ? LP('login', 'registrationSuccessfulAlertAriaLabel') : ''}></div>
                        <h1 className="register-title" style={styles}>
                            {LP('users', 'register', 'sentencecase')}
                        </h1>
                        {this.renderBody()}
                        {this.renderColumns(length)}
                    </div>
                </Card>
            </div>
        );
    }

});

export default RegisterNewUser;